/* @flow */

import montarSelectTipoEmpresa from './montar-select-tipo-empresa';
import api from '../../utils/api';

const carregarTiposEmpresa = async (selector: string) => {
    const { data } = await api.getTiposEmpresa();
    montarSelectTipoEmpresa(selector, data);
};

export default carregarTiposEmpresa;
